import styled, { css } from 'styled-components';

export const FooterWrap = styled.div`
  background: #fff;
  border-top: 1px solid #e6e6e6;
  padding: ${props => props.theme.spacing.custom(15)} ${props => props.theme.spacing.custom(30)};
  width: 100%;

  &.footerCol {
    padding-right: ${props => props.theme.spacing.custom(10)};
    min-width: 150px;
  }

  .footerHd {
    text-transform: uppercase;
    font-size: ${props => props.theme.font.custom(14)};

    padding-bottom: ${props => props.theme.spacing.custom(10)};
    color: #333333;
    height: 40px;
  }

  .footerEl {
    line-height: 1.5;
  }

  .footerLink {
    font-size: ${props => props.theme.font.custom(11)};
    text-decoration: none;
    color: #666666;
    padding-bottom: ${props => props.theme.spacing.custom(5)};
    &:hover {
      color: #f26722;
      text-decoration: underline;
    }
  }
`;

export const FooterCol = styled.div`
  padding-right: ${props => props.theme.spacing.custom(10)};
  min-width: 150px;
`;

export const FooterHd = styled.div`
  text-transform: uppercase;
  font-size: ${props => props.theme.font.custom(14)};

  padding-bottom: ${props => props.theme.spacing.custom(10)};
  color: #333333;
  height: 40px;
`;

export const FooterEle = styled.div`
  line-height: 1.5;
`;

export const FooterLink = styled.a`
  font-size: ${props => props.theme.font.custom(11)};
  text-decoration: none;
  color: #666666;
  padding-bottom: ${props => props.theme.spacing.custom(5)};
  &:hover {
    color: #f26722;
    text-decoration: underline;
  }
`;

export const FollowWrap = styled.div``;

export const BookTicketsWrap = styled.div``;

export const VerifiedWrap = styled.div`
  ${props =>
    props.url &&
    css`
      background: url('${props.url}') no-repeat 0 0;
    `}
  margin-right: ${props => props.theme.spacing.small};

  &.verified {
    background-position: -168px -40px;
    width: 61px;
    height: 31px;
  }

  &.amerexp {
    background-position: -130px -40px;
    width: 30px;
    height: 20px;
    margin-top: 5px;
  }

  &.master {
    background-position: -40px -40px;
    width: 30px;
    height: 20px;
    margin-top: 5px;
  }

  &.visa {
    background-position: 0 -40px;
    width: 30px;
    height: 20px;
    margin-top: 5px;
  }

  &.payu {
    background-position: -80px -40px;
    width: 35px;
    height: 20px;
    margin-top: 5px;
  }

  &.rupay {
    background-position: 0 -59px;
    width: 48px;
    height: 22px;
    margin-top: 2px;
  }

  &.iata {
    background-position: -59px -67px;
    width: 48px;
    height: 30px;
  }

  &.goibibo {
    background-position: -80px -130px;
    float: left;
    width: 57px;
    height: 29px;
    margin-right: 15px;
  }

  &.redbus {
    background-position: -138px -128px;
    float: left;
    width: 49px;
    height: 29px;
    margin-right: 15px;
  }
`;

export const VerifiedAppLink = styled.a``;

export const AppSprt = styled.a`
  ${props =>
    props.url &&
    css`
      background: url('${props.url}') no-repeat 0 0;
    `}
  margin-right: ${props => props.theme.spacing.small};

  &.GoogleApp {
    background-position: -8px -5px;
    width: 104px;
    height: 34px;
  }

  &.IphoneApp {
    background-position: -120px -5px;
    width: 105px;
    height: 34px;
  }

  &.WindowApp {
    background-position: -233px -5px;
    width: 104px;
    height: 34px;
  }
`;

export const FollowLink = styled.a`
  margin-right: 10px;
`;

export const AppHead = styled.div`
  font-size: ${props => props.theme.font.custom(16)};

  padding-bottom: ${props => props.theme.spacing.custom(10)};
`;

export const RoutesHead = styled.div``;
export const RoutesLink = styled.a`
  &:hover {
    color: #8e93ab;
  }
  text-decoration: none;
`;
